import $ from "jquery";
import BD_Component from "../core/bd-component";
import compile from "../utils/handlerbars-helper";
import { addDocument } from "@bd-core/firebase-actions";

export class RoomInventory extends BD_Component {
    constructor() {
        super();

        this.id = "inventory";
        this.templateID = "inventory-template";

        this.elms = {
            pointerBtn: ".js-pointer",
            closePopupBtn: ".js-close-popup",
            imageBox: ".js-imagebox",
            imageBoxFullscreen: ".js-imagebox-fullscreen",
            openFullscreenBtn: ".js-open-imagebox-fullscreen",
            closeFullscreenBtn: ".js-close-popup-fullscreen",
            imageBoxImg: ".js-imagebox-img",
            shareBtn: ".js-share-btn",
            snackbar: ".js-saved-document-snackbar",
            closeSnackbar: ".js-close-snackbar",
        };

        this._events = this.getEvents();

        this._data = {};
        this._questions = [];
        this._labels = [];
    }

    /**
     * @returns {Array<BD_ComponentEvent>}
     */
    getEvents() {
        const elms = this.elms;

        return [
            {
                event: "click",
                selector: elms.pointerBtn,
                handler: this.onHandlePointer,
            },
            {
                event: "click",
                selector: elms.closePopupBtn,
                handler: this.onCloseImagePopup,
            },
            {
                event: "click",
                selector: elms.openFullscreenBtn,
                handler: this.handleFullscreen,
            },
            {
                event: "click",
                selector: elms.closeFullscreenBtn,
                handler: this.onCloseFullsceenPopup,
            },
            {
                event: "click",
                selector: elms.shareBtn,
                handler: this.onAddDocument,
            },
            {
                event: "click",
                selector: elms.closeSnackbar,
                handler: this.onCloseSnackbar,
            },
        ];
    }

    beforeInit() {
        this.render();
        this.renderPlayRoom();
        this.setGameState();
    }

    getModifiedData() {
        const modified = { ...this._data };

        const hintHotspots = this._data.hotspots.filter(
            (h) => h["hotspot_type"] === "hint",
        );

        const docsHotspot = this._data.hotspots.filter(
            (h) => h["hotspot_type"] === "document",
        );

        const hotspotCount = hintHotspots.length;
        const defaultValue = "50%";

        const _hints = this._data.hints.map((hint, i) => {
            const font_fam = hint.hint_font_family.split("|");
            const font_name = font_fam[0];
            const font_category = font_fam[1];

            return {
                ...hint,
                font_family: `"${font_name}", ${font_category}`,
                has_image: hint.image,
                position_top:
                    hotspotCount > 0 && hintHotspots[i]
                        ? hintHotspots[i].position_top
                        : defaultValue,
                position_left:
                    hotspotCount > 0 && hintHotspots[i]
                        ? hintHotspots[i].position_left
                        : defaultValue,
            };
        });

        const _documents = this._data.documents.map((doc) => {
            const { document_id } = doc;
            const position = docsHotspot.find(
                (doc) => doc["document_id"] === document_id,
            );
            const position_top = position
                ? position["position_top"]
                : defaultValue;
            const position_left = position
                ? position["position_left"]
                : defaultValue;

            return {
                ...doc,
                position_top,
                position_left,
            };
        });

        const modifiedData = {
            ...modified,
            hints: _hints,
            documents: _documents,
        };

        return modifiedData;
    }

    render() {
        const modifiedData = this.getModifiedData();

        const htmlTemplate = $("#" + this.templateID).html();
        const html = compile(htmlTemplate, modifiedData);
        $(".app").html(html);
    }

    setGameState() {
        return false;
    }

    renderPlayRoom() {
        const startedAt = +new Date();
        const $playroom = $(".playroom").last();
        const $playroomImage = $playroom.find(".playroom-image");
        const $playroomWrapper = $playroom.find(".playroom-wrapper");

        // show error if onLoad not called more than 10s
        const waitLoad = setInterval(() => {
            const now = +new Date();
            const diff = now - startedAt;
            if (diff > 10 * 1000) {
                // showMessage(viewData.strings.playroom_image_error_load);
                clearInterval(waitLoad);
            }
        }, 100);

        const calculate = () => {
            const imageRatio = $playroomImage.height() / $playroomImage.width();
            const containerRatio = $playroom.height() / $playroom.width();

            let finalHeight;
            let finalWidth;

            if (containerRatio > imageRatio) {
                finalHeight = $playroom.height();
                finalWidth = $playroom.height() / imageRatio;
            } else {
                finalWidth = $playroom.width();
                finalHeight = $playroom.width() * imageRatio;
            }

            $playroomWrapper.css({
                height: finalHeight + "px",
                width: finalWidth + "px",
            });

            $playroomImage.css({
                height: finalHeight + "px",
                width: finalWidth + "px",
            });

            $playroom.addClass("is-calculated");
        };

        const markAsLoaded = () => {
            clearInterval(waitLoad);
        };

        const onLoad = () => {
            calculate();
            markAsLoaded();
        };

        // if image loaded directly from cached file, it wont trigger onload
        // @ts-ignore
        if ($playroomImage[0].complete) onLoad();
        $playroomImage.on("load", onLoad);
    }

    onHandlePointer(e) {
        const elms = this.elms;
        const $this = $(e.currentTarget);
        const $imagebox = $(elms.imageBox);
        const $title = $(".playroom-imagebox-title");
        const $description = $(".playroom-imagebox-description");
        const $image = $(".playroom-imagebox-image");
        const title = $this.attr("data-title");
        const docId = $this.attr("data-id");
        const description = $this.data("description");
        const image = $this.data("image");
        const isFullscreen = $this.hasClass("is-fullscreen");
        const newImage = new Image();

        // This is to determine whether tutorial can be shown or not
        // because Tutorial should only be open only if $imagebox is open
        // and $image has been loaded successfully
        // `I` stands for `imagebox`
        // let hasIOpened = false;
        // let hasILoaded = false;

        // const onFinishTransition = () => {
        //     // Prevent prematurely show tutorial when the email hasn't open yet
        //     if (!$imagebox.hasClass('is-open')) return false;

        //     hasIOpened = true;
        //     // showTutorial();
        // };

        // const transitionEndEvent = getTransitionEndEvent();
        // $imagebox.on(transitionEndEvent, onFinishTransition);

        newImage.src = image;
        newImage.onload = function () {
            $image.removeClass("is-loading");
            // hasILoaded = true;
            // showTutorial();
        };

        if (isFullscreen) {
            $imagebox.addClass("is-fullscreen");
        } else {
            $imagebox.removeClass("is-fullscreen");
        }

        $title.html(title);
        $description.html(description);
        $image.find("img").remove();
        $image.addClass("is-loading").append(newImage);
        $imagebox.addClass("is-open");

        $(elms.shareBtn).attr("data-id", docId);
        $(elms.shareBtn).attr("data-url", image);
        $(elms.shareBtn).attr("data-title", title);

        if (
            title.toLowerCase() == "ceo's laptop" ||
            title.toLowerCase() == "chairwoman's laptop"
        ) {
            $imagebox.addClass("is-ceo-laptop");
        } else {
            $imagebox.removeClass("is-ceo-laptop");
        }
    }

    onCloseImagePopup() {
        $(this.elms.imageBox).removeClass("is-open");
    }

    handleFullscreen() {
        const elms = this.elms;
        const $selectedImg = $(elms.imageBoxImg).find("img");
        const $imageboxFullscreen = $(elms.imageBoxFullscreen);
        const $fullscreenWrapper = $imageboxFullscreen.find(
            ".popup-fullscreen-wrapper",
        );
        const $existingImg = $fullscreenWrapper.find("img");

        if ($existingImg.length) {
            $existingImg.removeClass("is-active");
            $existingImg.remove();
        }

        $selectedImg
            .clone(true)
            .addClass("is-active")
            .appendTo($fullscreenWrapper);
        $imageboxFullscreen.addClass("is-open");
    }

    onCloseFullsceenPopup() {
        const elms = this.elms;
        const $imageboxFullscreen = $(elms.imageBoxFullscreen);
        $imageboxFullscreen.removeClass("is-open");
    }

    onAddDocument(e) {
        const $this = $(e.currentTarget);
        const id = $this.attr("data-id");
        const url = $this.attr("data-url");
        const title = $this.attr("data-title");

        const docObj = {
            [id]: {
                url,
                title,
            },
        };

        addDocument(docObj)
            .then(() => {
                $(".js-saved-document-snackbar").addClass("is-open");
                setTimeout(() => {
                    $(".js-saved-document-snackbar").removeClass("is-open");
                }, 3000);
            })
            .catch(() => console.error("failed"));
    }

    onCloseSnackbar() {
        $(this.elms.snackbar).removeClass("is-open");
    }
}
